import { React, useEffect } from 'react'

import { lP } from '../../main.js'

export default function LoginPW() {

    useEffect(() => {
        lP('/login')
    }, [])

    return null
}
